import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'

import BlurhashImg from '@/components/global/BlurhashImg.vue'
import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyImage',
  props: {
    src: null,
    immediate: { type: Boolean }
  },
  emits: ["loaded"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'loaded'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  src: string
  immediate?: boolean
};





const isLoaded = ref(false)
const wrapper = ref<HTMLElement>()
const image = ref<HTMLImageElement>()
const store = useStore()

const storedHash = computed(() => {
  if (!props.src) return null

  const uuid = props.src.split('/')[6]
  return store.getHashByUuid(uuid)?.hash
})

const onEnter = () => {
  if (isLoaded.value || !image.value) return

  image.value.src = props.src
  image.value.onload = () => {
    setTimeout(() => {
      isLoaded.value = true
      emit('loaded')
    }, 350)
  }
}

onMounted(() => {
  if (props.immediate) onEnter()
})

useIntersectionObserver(
  wrapper,
  ([{ isIntersecting }]) => {
    isIntersecting && onEnter()
  },
  {
    threshold: 0,
    rootMargin: '300px',
  }
)

return (_ctx: any,_cache: any) => {
  return (__props.src)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "wrapper",
        ref: wrapper,
        class: "lazy-wrapper"
      }, [
        (_unref(storedHash))
          ? (_openBlock(), _createBlock(BlurhashImg, {
              key: 0,
              hash: _unref(storedHash),
              "aspect-ratio": 1,
              class: _normalizeClass(["blurhash", isLoaded.value ? null : 'opacity-100'])
            }, null, 8, ["hash", "class"]))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          ref_key: "image",
          ref: image,
          draggable: "false",
          class: _normalizeClass(["image", isLoaded.value ? 'opacity-100' : 'opacity-0'])
        }, null, 2)
      ], 512))
    : _createCommentVNode("", true)
}
}

})